// Outer
import React, { useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

// Inner
import useQueryParams from '../hooks/useQueryParams';

export interface TabNode<T> {
  title: string;
  icon: React.ReactElement;
  component: React.ComponentType<T>;
}

interface TabLayoutProps<T> {
  tabs: TabNode<T>[];
  hideTabs?: boolean;
  initialTabIndex?: number;
  children: (TabComponent: React.ComponentType<T>) => React.ReactNode;
  onTabChange: (tabTitle: string, tabIndex: number) => void;
  tabStyles?: any;
}

export default function TabLayout<T>({
  initialTabIndex = 0,
  tabs,
  hideTabs = false,
  children,
  onTabChange,
  tabStyles,
}: TabLayoutProps<T>) {
  const { tabName } = useQueryParams();
  const [tabIndex, setTabIndex] = React.useState(initialTabIndex);

  useEffect(() => {
    const index = tabs.findIndex(next => next.title === tabName);

    if (index !== -1) {
      setTabIndex(index);
    }
  }, [tabName, tabs]);

  const handleTabChange = (e: React.ChangeEvent<{}>, index: number) => {
    setTabIndex(index);
    const newTab = tabs[index];
    onTabChange(newTab.title, index);
  };
  const TabComponent = tabs[tabIndex].component;

  return (
    <>
      {!hideTabs && (
        <Box display="flex" alignItems="center" alignContent="center">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
            style={{ width: "100%" }}
          >
            {tabs.map(tab => (
              <Tab style={{ ...tabStyles }} key={tab.title} label={tab.title} icon={tab.icon} />
            ))}
          </Tabs>
        </Box>
      )}
      {children(TabComponent)}
    </>
  );
}
